import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useCustomerAuthContext } from "../commoncomponents/useCustomerAuthContext";

function TestCustomerHome() {

    const { customer } = useCustomerAuthContext();

    if (!customer) {
        return (
            <div className="p-8">
                Loading...
            </div>
        );
    }

    return (
        <div className="p-8">

            <h1>
              Welcome, {customer.lastName} 👋
          </h1>

            <p className="mt-3">
                Customer authentication successful.
            </p>

            
            <div className="mt-6">
                <Link
                    to="/customer/test/pdf"
                    className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                    Test PDF Generation
                </Link>
            </div>

        </div>

        
    );
}

export default TestCustomerHome;